import React from 'react';
import { Link } from 'react-router-dom';
import type { SolutionPremiumSections } from './types';
import { useTabPanel } from './useTabPanel';

export const SolutionEduTabs: React.FC<{
  education: SolutionPremiumSections['education'];
}> = ({ education }) => {
  const { active, getPanelProps, getTabProps } = useTabPanel(education.tabs);

  const handleCtaClick = (to: string) => {
    if (to !== '#faqs') return;
    const el = document.getElementById('faqs');
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="solution-edu solution-edu--premium" aria-label="Solution overview">
      <div className="solution-edu__inner solution-edu__inner--premium">
        <div className="solution-edu__shell">
          <div className="solution-edu__tabs solution-edu__tabs--premium" role="tablist">
            {education.tabs.map((tab) => {
              const selected = tab.id === active.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  className={`solution-edu__tab solution-edu__tab--premium${
                    selected ? ' solution-edu__tab--premium-active' : ''
                  }`}
                  {...getTabProps(tab, selected)}
                >
                  {tab.label}
                </button>
              );
            })}
          </div>
          {education.tabs.map((tab) => {
            const selected = tab.id === active.id;
            return (
              <div
                key={tab.id}
                className={`solution-edu__panel solution-edu__panel--premium${
                  selected ? ' solution-edu__panel--premium-active' : ''
                }`}
                {...getPanelProps(tab)}
              >
                {tab.blocks && tab.blocks.length > 0 ? (
                  <div className="solution-edu__columns">
                    {tab.blocks.map((block) => (
                      <div key={block.title} className="solution-edu__column">
                        <h3 className="solution-edu__column-title">{block.title}</h3>
                        <p className="solution-edu__column-desc">{block.description}</p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="solution-edu__single">
                    <h3 className="solution-edu__panel-title solution-edu__panel-title--premium">{tab.title}</h3>
                    <ul className="solution-edu__list solution-edu__list--premium">
                      {tab.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {tab.cta ? (
                  <Link
                    to={tab.cta.to}
                    className="solution-edu__cta solution-edu__cta--premium"
                    onClick={() => handleCtaClick(tab.cta!.to)}
                  >
                    {tab.cta.label}
                  </Link>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
